import { RouteRecordRaw, RouterView } from 'vue-router'

export default {
    name: 'basketball-talent-pool',
    path: '/basketball-talent-pool',
    redirect: '/basketball-talent-pool/home',
    component: RouterView,
    children: [
        {
            name: 'talents-pool-home',
            path: 'home',
            component: () => import('@/view/basketball-talent-pool/home/Index.vue'),
        },
        {
            name: 'five-bastketball-talent',
            path: 'five',
            meta: {
                title: '国家队5人男篮人才库名单',
            },
            component: () => import('@/view/basketball-talent-pool/five-basketball-talent/Index.vue'),
        },
        {
            name: 'personal-data',
            path: 'data',
            component: () => import('@/view/basketball-talent-pool/personal-data/Index.vue'),
        },
        {
            name: 'introduction-talent-pool',
            path: 'coach',
            component: () => import('@/view/basketball-talent-pool/introduction-the-coach/Index.vue'),
        },
        {
            name: 'five-coach-talent',
            path: 'five-coach-talent',
            component: () => import('@/view/basketball-talent-pool/five-basketball-talent/Talent.vue'),
        },
        {
            name: 'three-basketball-talent',
            path: 'three',
            component: () => import('@/view/basketball-talent-pool/three-basketball-talent/Index.vue'),
        },

        {
            name: 'report-data',
            path: 'report-data',
            meta: {
                title: '',
            },
            component: () => import('@/view/basketball-talent-pool/report-data/Index.vue'),
        },
        {
            name: 'report-show',
            path: 'report-show',
            meta: {
                title: '人才详情',
            },
            component: () => import('@/view/basketball-talent-pool/report-data/show.vue'),
        },
        {
            name: 'foreignCoachHome',
            path: 'home',
            meta: {
                title: '外籍教练评选',
            },
            component: () => import('@/view/foreign-coach/index.vue'),
        },
        {
            name: 'foreignCoachInfo',
            path: 'info',
            meta: {
                title: '外籍教练评选',
            },
            component: () => import('@/view/foreign-coach/Info.vue'),
        },
    ],
} as RouteRecordRaw
